import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component';
import { QueryModelApiConfiguration } from 'app/shared/services/queryModel/apiConfiguration';
import { UserRolesCloner } from 'app/shared/models';

@Injectable()
export class CopyUserRolesService extends ServiceBase {
    private readonly actionUrl: string;
    private readonly post: string;

    constructor(private _http: HttpClient, private _configuration: QueryModelApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.post = this.actionUrl + _configuration.userRolesCloner.url;
    }

    copyUserRoles(dto: UserRolesCloner): Observable<any> {
        return this._http.post<any>(this.post, dto);
    }
}